import { ScheduleStatus, } from '@wix/ambassador-services-catalog-server/types';
import { ServiceType, } from '@wix/bookings-uou-types';
import { mapServiceLocations } from './service-location.mapper';
import { mapServiceOfferedAsDto } from './service-offered-as.mapper';
import { mapServicePricingPlansDto } from './service-pricing-plans.mapper';
import { mapServicePaymentDto } from './service-payment.mapper';
export function mapCatalogServiceResponseToService(serviceResponse) {
    const schedule = serviceResponse.schedules.find((serviceSchedule) => serviceSchedule.status === ScheduleStatus.CREATED);
    const { service } = serviceResponse;
    return {
        id: service.id,
        info: mapServiceInfo(serviceResponse),
        staffMembers: mapStaffMembers(serviceResponse),
        policy: mapServicePolicy(service, schedule),
        payment: mapServicePayment(serviceResponse),
        locations: mapServiceLocations(schedule),
        includeConferenceOption: service.includeConferenceOption,
    };
}
function mapServiceInfo(serviceResponse) {
    const schedule = serviceResponse.schedules.find((serviceSchedule) => serviceSchedule.status === ScheduleStatus.CREATED);
    const { info } = serviceResponse.service;
    let media = {
        gallery: [],
    };
    if (info.media) {
        const { mainMedia, coverMedia, items } = info.media;
        media = {
            mainMedia: mainMedia && mainMedia.image
                ? mapImageToMediaItem(mainMedia.image)
                : undefined,
            coverMedia: coverMedia && coverMedia.image
                ? mapImageToMediaItem(coverMedia.image)
                : undefined,
            gallery: items
                ? items.map((item) => mapImageToMediaItem(item.image))
                : [],
        };
    }
    else {
        media.mainMedia = info.images?.[0]
            ? mapImageToMediaItem(info.images[0])
            : undefined;
    }
    const duration = schedule?.availability?.constraints?.slotDurations?.[0];
    return {
        name: info?.name,
        slugs: mapServiceSlugs(serviceResponse.slugs),
        type: mapServiceType(schedule),
        tagline: info?.tagLine,
        categoryId: serviceResponse.category?.id,
        categoryName: serviceResponse.category?.name,
        media,
        duration,
    };
}
const mapServiceSlugs = (slugs) => {
    return slugs
        .sort((slug1, slug2) => new Date(slug2.createdAt).valueOf() -
        new Date(slug1.createdAt).valueOf())
        .map((slug) => slug.name);
};
function mapImageToMediaItem(image) {
    return {
        height: image.height,
        width: image.width,
        relativeUri: image.url,
        fileName: image.filename || image.url,
        altText: image.altText,
    };
}
function mapServiceType(schedule) {
    return schedule.tags
        ? schedule.tags.find((tag) => tag === ServiceType.COURSE ||
            tag === ServiceType.GROUP ||
            tag === ServiceType.INDIVIDUAL) || ServiceType.INDIVIDUAL
        : ServiceType.INDIVIDUAL;
}
export function mapServicePayment(serviceResponse) {
    return {
        offeredAs: mapServiceOfferedAsDto(serviceResponse),
        pricingPlanInfo: mapServicePricingPlansDto(serviceResponse, {
            onlyActive: true,
        }),
        paymentDetails: mapServicePaymentDto(serviceResponse),
    };
}
function mapServicePolicy(service, schedule) {
    return {
        uouHidden: service.customProperties?.uouHidden === 'true',
        isBookOnlineAllowed: service.policy?.isBookOnlineAllowed,
        isPendingApprovalFlow: !!service.policy?.bookingsApprovalPolicy?.isBusinessApprovalRequired,
        maxParticipantsPerBook: service.policy?.maxParticipantsPerBooking,
        capacity: schedule.capacity,
        minutesBeforeSlotBookWindowStart: service.policy?.futureBookingsPolicy?.limitXMinutesToTheFuture,
        minutesBeforeSlotBookWindowEnd: service.policy?.bookUpToXMinutesBefore,
    };
}
function mapStaffMembers(serviceResponse) {
    const { resources } = serviceResponse;
    return resources?.map((resource) => {
        return {
            id: resource.id,
            name: resource.name,
        };
    });
}
//# sourceMappingURL=service.mapper.js.map